export const getNoiseDomains = ():any => {
  let nd = getNoiseDomainStr().split(/[ \t\r\n]+/)

  let ndMap:any = {}
  for(let i=0; i < nd.length; i++) {
    let d:any = nd[i];
    if(d != "") {
      ndMap[d] = true;
    }
  }
  return ndMap;

}
export const getNoiseDomainStr = ():string => {
  let noiseDomainStr= `
dash.kibosh.com
ddns1.kibosh.com
ddns2.kibosh.com
ddns3.kibosh.com
ddns4.kibosh.com
ddns5.kibsoh.com
googleapis.com
gstatic.com
a2z.com
agnss.goog
app-measurement.com
doubleclick.net
doubleclick.net
omtrdc.net
googleusercontent.com
bitdrift.io
nr-data.net
gstatic.com
akadns.net
px-cloud.net
cdn-apple.com
googlesyndication.com
w55c.net
bravesoftware.com
digicert.com
wpad.lan
windowsupdate.com
exp-tas.com
in-addr.arpa
_udp.lan
ytimg.com
googletagservices.com
googleadservices.com
googlevideo.com
in-addr.arpa
boxcdn.net
apple-dns.net
aaplimg.com
apple-cloudkit.com
kiboshfilter.com
cloudfront.net
a2z.com
amazonaws.com
awsglobalaccelerator.com
nr-data.net
recaptcha.net
trafficmanager.net
safebrowsing.apple
resolver.arpa
servedbyadbutler.com
azurewebsites.net
visualwebsiteoptimizer.com
gvt1.com
dropboxstatic.com
edgesuite.net
dropboxusercontent.com
storyblok.com
azurewebsites.net
cloud.microsoft
office.net
akadns.net
office.com
dns.google
msidentity.com
akamaiedge.net
dropbox-dns.com
dual-s-msedge.net
akamai.net
fastly-edge.com
appwork.org
apple-cloudkit.com
slack-edge.com
mzstatic.com
akahost.net
dropboxstatic.com
gvt1.com
`;
  return noiseDomainStr;
}
